export default "__VITE_ASSET__DPPSJ$eG__"